import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatCheckboxChange } from '@angular/material/checkbox';

import { TableColumn, ToggleColumnProperty } from 'src/app/models/table';
import { TableColumnType } from 'src/app/constants/table';
import { TableService } from 'src/app/services/table.service';
import { TextType } from 'src/app/constants/text-type';
import { SvgColor, SvgMatType } from 'src/app/constants/icons';
import { HelperService } from 'src/app/services/helper.service';

@Component({
    selector: 'mwp-table',
    templateUrl: './table.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TableComponent implements OnChanges {
    @Input() public header: string;
    @Input() public subheader: string;
    @Input() public nameInHeader: string; // variable that goes inside header but is never Translated
    @Input() public tableColumns: TableColumn[];
    @Input() public dataSource: MatTableDataSource<any>;
    @Input() public tableId: number;
    @Input() public translateHeader: boolean = true;
    @Input() public isModal: boolean = false;
    @Input() public isCustomColumnNameMatchValueName: boolean = false;

    @Output() public emitButtonSelection: EventEmitter<any> = new EventEmitter();
    @Output() public emitButtonSelection2: EventEmitter<any> = new EventEmitter();
    @Output() public emitIconButton: EventEmitter<any> = new EventEmitter();
    @Output() public emitHyperLink: EventEmitter<any> = new EventEmitter();

    public columnType = TableColumnType;
    public renderdColumns: string[] = [];
    public currentId: number;
    public isLoaded: boolean;
    public isSelectAll: boolean;

    constructor(
        private tableService: TableService,
        private router: Router,
        private helperService: HelperService,
    ) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        //if (changes.firstChange || changes.previousValue != changes.currentValue) {
        this.isLoaded = false;
        this.renderdColumns = this.tableService.extractTableColumnNames(this.tableColumns);
        this.currentId = this.tableId;
        this.isLoaded = true;
        //}
    }

    // HACK - This automatically updates a header column name when changed
    // How does this work, Only god knows now
    trackByIndex(i: any): any {
        return i;
    }

    public displayElement(tableColumn: TableColumn, type: TableColumnType, element: any): boolean {
        return this.tableService.displayElement(tableColumn, type, element);
    }

    public findElementByColumnName(element: any, columnName: string, textType: TextType): string {
        return this.tableService.findElementByColumnName(element, columnName, textType, this.isCustomColumnNameMatchValueName);
    }

    public findElementBoolean(element: any, columnName: string): boolean {
        if (columnName == null)
            return true;

        return this.tableService.findElementByColumnName(element, columnName, null, this.isCustomColumnNameMatchValueName);
    }

    public selectAll(event: MatCheckboxChange, tableColumn: TableColumn): void {
        if (Array.isArray(this.dataSource.data)) {
            this.dataSource.data.map((ds) => {
                for (const prop in ds) {
                    if (prop == tableColumn.propertyId) {
                        ds[prop] = event.checked;
                    }
                }
            });
        }
    }

    public selectAllChange(event: MatCheckboxChange, tableColumn: TableColumn): void {
        let l_IsAllChecked: boolean = true;

        if (Array.isArray(this.dataSource.data)) {
            this.dataSource.data.map((ds) => {
                for (const prop in ds) {
                    if (ds[prop] == tableColumn.propertyId) {
                        if (!ds[prop])
                            l_IsAllChecked = false;
                    }
                }
            });
        }

        this.isSelectAll = l_IsAllChecked;
    }

    public selection($event: any, tableColumn: TableColumn): void {
        if (tableColumn.columnType == TableColumnType.iconButton) {
            this.emitIconButton.emit($event);
            return;
        }

        if (tableColumn.isButtonSelection2)
            this.emitButtonSelection2.emit($event);
        else
            this.emitButtonSelection.emit($event);
    }

    public openLink(url: string, isNewTab: boolean, isEmit: boolean, $event: any): void {
        if (isNewTab)
            window.open(url, "_blank");
        else if (isEmit)
            this.emitHyperLink.emit($event);
        else
            this.router.navigateByUrl(url);
    }

    public displayIconButton(element: any, tableColumn: TableColumn): boolean {
        return this.tableService.displayIconButton(element, tableColumn);
    }

    public findSVGType(element: any, tableColumn: TableColumn): SvgMatType {
        const l_MatId = tableColumn.svgPropertyId ? element[tableColumn.svgPropertyId] : tableColumn.svgCustomName;
        return SvgMatType[this.helperService.getEnumByKey(SvgMatType, l_MatId)];
    }

    public findSVGTypeByCustomName(customName: string): SvgMatType {
        return SvgMatType[this.helperService.getEnumByKey(SvgMatType, customName)];
    }

    public findSVGColor(cssClass: string): SvgColor {
        return SvgColor[this.helperService.getEnumByKey(SvgColor, cssClass)];
    }
}
